import { useNotificationAPI, useNotificationData } from '../components/NotificationProvider';
import { Fade } from "@progress/kendo-react-animation";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";

const position = {
    topCenter: { top: 0, left: "50%", transform: "translateX(-50%)" },
};

const NotificationPopup = () => {
    const { removeNotificationFromPopup } = useNotificationAPI();
    const { popupNotifications } = useNotificationData();

    return (
        <NotificationGroup style={position.topCenter}>
            {popupNotifications?.map((notification, index) => (
                <Fade key={index} enter={true} exit={true}>
                    <Notification type={{ style: notification.type, icon: true }} closable={true} onClose={() => removeNotificationFromPopup(notification.time)}>
                        <span>{notification.text}</span>
                    </Notification>
                </Fade>
            ))}
        </NotificationGroup>
    );
};

export default NotificationPopup;
